<div class="summary-list-item" (click)="handleDeeplink(item.deeplink)">
  <p class="item-title">{{ item.title }} ({{ item.quantity }})</p>

  <p class="amount">
    {{ item.totalAmount | money: currencyCode:locale }}
  </p>
</div>
